<template>
  <layout-breadcrumb-cartao
    titulo="Gestão de Recursos e Serviços Próprios"
    :breadcrumb="bread"
    :iconeSvg="RecursosPropriosSvg"
  >
    <TabelaRecursosProprios />
  </layout-breadcrumb-cartao>
</template>

<script>
import TabelaRecursosProprios from "./shared/componentes/TabelaRecursosProprios.vue";
// import TabelaPrestadores from "../Prestadores/shared/componentes/TabelaPrestadores.vue";

export default {
  components: { TabelaRecursosProprios },
  data() {
    return {
      bread: [
        { titulo: "Início", url: "/home" },
        { titulo: "Gestão de Recursos e Serviços Próprios" }
      ]
    };
  }
};
</script>
